import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Standings from './components/Standings.vue'
import Schedule from './components/Schedule.vue'
import Statistics from './components/Statistics.vue'
import Teams from './components/Teams.vue'
import Rosters from './components/Rosters.vue'
import RostersShow from './components/RostersShow.vue'
import Calendar from './components/Calendar.vue'
import Playoffs from './components/Playoffs.vue'
import Signup from './components/Signup.vue'
import Signin from './components/Signin.vue'
import AdminHome from './components/AdminHome.vue'
import AdminSeasons from './components/AdminSeasons.vue'
import AdminSeasonsNew from './components/AdminSeasonsNew.vue'
import AdminTeams from './components/AdminTeams.vue'
import AdminTeamsNew from './components/AdminTeamsNew.vue'
import AdminTeamsEdit from './components/AdminTeamsEdit.vue'
import AdminDivisions from './components/AdminDivisions.vue'
import AdminDivisionsNew from './components/AdminDivisionsNew.vue'
import AdminDivisionsEdit from './components/AdminDivisionsEdit.vue'
import AdminMatches from './components/AdminMatches.vue'
import AdminMatchesNew from './components/AdminMatchesNew.vue'
import AdminMatchesEdit from './components/AdminMatchesEdit.vue'
import AdminPlayoffs from './components/AdminPlayoffs.vue'
import AdminPlayoffsRoundNew from './components/AdminPlayoffsRoundNew.vue'
import AdminPlayoffsMatchupNew from './components/AdminPlayoffsMatchupNew.vue'
import AdminPlayoffsMatchEdit from './components/AdminPlayoffsMatchEdit.vue'
import AdminPlayers from './components/AdminPlayers.vue'
import AdminPlayersNew from './components/AdminPlayersNew.vue'
import AdminPlayersEdit from './components/AdminPlayersEdit.vue'
import AdminPlayersStats from './components/AdminPlayersStats.vue'
import AdminPlayersStatsNew from './components/AdminPlayersStatsNew.vue'
import AdminPlayersStatsEdit from './components/AdminPlayersStatsEdit.vue'
import AdminRosters from './components/AdminRosters.vue'
import AdminRostersNew from './components/AdminRostersNew.vue'
import AdminRostersEdit from './components/AdminRostersEdit.vue'
import AdminPlayersPositions from './components/AdminPlayersPositions.vue'
import AdminPlayersPositionsNew from './components/AdminPlayersPositionsNew.vue'
import AdminPlayersPositionsEdit from './components/AdminPlayersPositionsEdit.vue'
import AdminLocations from './components/AdminLocations.vue'
import AdminLocationsNew from './components/AdminLocationsNew.vue'
import AdminLocationsEdit from './components/AdminLocationsEdit.vue'
import Info from './components/Info.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/index.html',
            component: Standings,
            redirect: '/'
        },
        {
            path: '/',
            component: Standings,
            redirect: '/standings'
        },
        {
            path: '/standings',
            name: 'standings',
            component: Standings
        },
        {
            path: '/schedule',
            name: 'schedule',
            component: Schedule
        },
        {
            path: '/statistics',
            name: 'statistics',
            component: Statistics
        },
        {
            path: '/playoffs',
            name: 'playoffs',
            component: Playoffs
        },
        {
            path: '/teams',
            name: 'teams',
            component: Teams
        },
        {
            path: '/rosters',
            name: 'rosters',
            component: Rosters
        },
        {
            path: '/rosters/show/:id',
            name: 'rosters_show',
            component: RostersShow,
            props: true,
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar
        },
        {
            path: '/info',
            name: 'info',
            component: Info
        },
        {
            path: '/signup',
            name: 'signup',
            component: Signup
        },
        {
            path: '/signin',
            name: 'signin',
            component: Signin
        },
        {
            path: '/admin',
            name: 'admin',
            component: AdminHome,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/seasons',
            name: 'admin_seasons',
            component: AdminSeasons,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/seasons/new',
            name: 'admin_seasons_new',
            component: AdminSeasonsNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/teams',
            name: 'admin_teams',
            component: AdminTeams,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/teams/new',
            name: 'admin_teams_new',
            component: AdminTeamsNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/teams/edit/:id',
            name: 'admin_teams_edit',
            component: AdminTeamsEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/divisions',
            name: 'admin_divisions',
            component: AdminDivisions,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/divisions/new',
            name: 'admin_divisions_new',
            component: AdminDivisionsNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/divisions/edit/:id',
            name: 'admin_divisions_edit',
            component: AdminDivisionsEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/matches',
            name: 'admin_matches',
            component: AdminMatches,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/matches/new',
            name: 'admin_matches_new',
            component: AdminMatchesNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/matches/edit/:id',
            name: 'admin_matches_edit',
            component: AdminMatchesEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/playoffs',
            name: 'admin_playoffs',
            component: AdminPlayoffs,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/playoffs/new_round',
            name: 'admin_playoffs_round_new',
            component: AdminPlayoffsRoundNew,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/playoffs/new_matchup',
            name: 'admin_playoffs_matchup_new',
            component: AdminPlayoffsMatchupNew,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/playoffs/edit_match',
            name: 'admin_playoffs_match_edit',
            component: AdminPlayoffsMatchEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players',
            name: 'admin_players',
            component: AdminPlayers,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players/new',
            name: 'admin_players_new',
            component: AdminPlayersNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players/edit/:id',
            name: 'admin_players_edit',
            component: AdminPlayersEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players_stats',
            name: 'admin_players_stats',
            component: AdminPlayersStats,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players_stats/new',
            name: 'admin_players_stats_new',
            component: AdminPlayersStatsNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players_stats/edit/:id',
            name: 'admin_players_stats_edit',
            component: AdminPlayersStatsEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/rosters',
            name: 'admin_rosters',
            component: AdminRosters,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/rosters/new',
            name: 'admin_rosters_new',
            component: AdminRostersNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/rosters/edit/:id',
            name: 'admin_rosters_edit',
            component: AdminRostersEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players_positions/new',
            name: 'admin_players_positions_new',
            component: AdminPlayersPositionsNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players_positions',
            name: 'admin_players_positions',
            component: AdminPlayersPositions,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/players_positions/edit/:id',
            name: 'admin_players_positions_edit',
            component: AdminPlayersPositionsEdit,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/locations',
            name: 'admin_locations',
            component: AdminLocations,
            props: true,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/locations/new',
            name: 'admin_locations_new',
            component: AdminLocationsNew,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/admin/locations/edit/:id',
            name: 'admin_locations_edit',
            component: AdminLocationsEdit,
            props: true,
            meta: {
                authRequired: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.authRequired)) {
        if (!store.state.isAuthenticated) {
            next({
                path: '/signin',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
